import React from "react";

/**
 * Gegee AI brand logo. Renders the inline SVG so it can inherit color
 * via `currentColor` or be wrapped in a gradient container.
 */
export default function Logo({ className = "h-5 w-5", ...props }) {
  return (
    <svg
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      <g transform="translate(0,512) scale(0.1,-0.1)">
        <path d="M2485 4760 c-418 -35 -759 -186 -1031 -455 -205 -203 -339 -462 -389 -754 -31 -173 -15 -478 34 -641 100 -342 345 -661 656 -858 141 -88 371 -178 550 -213 108 -21 457 -19 563 4 535 115 967 491 1127 981 30 92 55 202 69 299 l5 37 -309 0 -308 0 -22 -71 c-66 -219 -199 -390 -388 -501 -158 -92 -293 -130 -472 -130 -424 -2 -767 254 -882 658 -18 64 -22 102 -21 204 1 145 23 241 78 359 113 238 307 394 584 469 l96 26 491 4 490 3 284 284 c156 156 281 287 278 291 -11 10 -1362 14 -1483 4z" />
        <path d="M3265 1396 c-127 -258 -421 -428 -740 -429 -216 0 -393 70 -580 228 l-67 58 -202 -202 -201 -202 50 -45 c320 -286 576 -407 946 -444 433 -44 929 180 1200 543 86 116 173 297 204 427 14 58 25 113 25 123 0 16 -21 17 -299 17 l-299 0 -37 -74z" />
      </g>
    </svg>
  );
}

/**
 * Standard inline brand block: gradient pill + logo + word-mark.
 * Use everywhere we previously had a Phone icon next to "Gegee AI".
 */
export function BrandMark({ size = "md", showText = true, className = "" }) {
  const sizes = {
    sm: { box: "h-7 w-7 rounded-md", icon: "h-3.5 w-3.5", text: "text-base" },
    md: { box: "h-9 w-9 rounded-xl", icon: "h-5 w-5", text: "text-lg" },
    lg: { box: "h-12 w-12 rounded-2xl", icon: "h-7 w-7", text: "text-2xl" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <span className={`relative flex ${s.box} items-center justify-center bg-gradient-to-br from-primary to-magenta shadow-glow text-white`}>
        <Logo className={s.icon} />
      </span>
      {showText && (
        <span className={`${s.text} font-extrabold tracking-tight text-white`}>
          Gegee<span className="text-gradient">AI</span>
        </span>
      )}
    </span>
  );
}
